import { Box, Container, Paper, Typography } from '@mui/material';
import { useEffect } from 'react';
import { SignIn, useAuth } from '@clerk/clerk-react';

const LoginPage = () => {
  const { isSignedIn } = useAuth();
  const signInRedirectUrl = '/api/auth/signin';

  useEffect(() => {
    if (isSignedIn) {
      window.location.assign(signInRedirectUrl);
    }
  }, [isSignedIn, signInRedirectUrl]);

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '70vh', md: '75vh' },
        py: { xs: 8, md: 12 },
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: '100%',
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome Back
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign in to continue to GroupMyChannels.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <SignIn
            routing="path"
            path="/login"
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/api/auth/signin"
            oauthFlow="redirect"
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;
